import { render } from "./ProductList.vue?vue&type=template&id=4ee7c39e"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"
script.render = render

export default script